import { render, staticRenderFns } from "./Transparency.vue?vue&type=template&id=456df0ec&scoped=true&"
var script = {}
import style0 from "./Transparency.vue?vue&type=style&index=0&id=456df0ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456df0ec",
  null
  
)

export default component.exports